module.exports = __webpack_public_path__ + "img/hot-tag.9930d5e5.png";